import React from 'react';
import { capitalize } from '../../utilities/strings';
import { useTranslation } from '@michelin/central-provider';
var StringCell = function (props) {
    var t = useTranslation().t;
    return (React.createElement("div", null, capitalize(t(props.value))));
};
export default StringCell;
//# sourceMappingURL=StringCell.js.map